// extracted by mini-css-extract-plugin
export default {"container":"Card_container__lCBzk","titleContainer":"Card_titleContainer__n6dVB"};